const API_ENDPOINT = 'https://manager.globalcoss.com';

export const environment = {
    production: true,
    apiEndpoint: API_ENDPOINT,
    apiLoginEndpoint: API_ENDPOINT + '/oauth/v2/token',
    imageEndpoint: API_ENDPOINT + '/images/',
    version: '2.9.2',
    buildNumber: 20902,
    debugTranslations: false,
};

